/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1GetTaxoparkWithdrawalSecretsResponse } from '../../entities/v1/GetTaxoparkWithdrawalSecretsResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1TaxoparkWithdrawalSecretModelSchema } from './taxoparkWithdrawalSecretModelSchema'
import { z } from 'zod'

export const v1GetTaxoparkWithdrawalSecretsResponseSchema = z.object({
  taxopark_withdrawal_secrets: z.array(z.lazy(() => v1TaxoparkWithdrawalSecretModelSchema)),
}) as unknown as ToZod<V1GetTaxoparkWithdrawalSecretsResponse>